import { Provider } from "react-redux";
import Routers from "./Routes";
import Store from "./ReaduxToolkit/Store";
import { ToastContainer } from "react-toastify";
import HumanHelp from "./Components/HumanHelp";
import { BrowserRouter } from "react-router-dom";

const App = () => {
  
  return (
    <>
      <Provider store={Store} >
        <BrowserRouter basename={"/"}>
          <Routers />
          <ToastContainer />
          <HumanHelp />
        </BrowserRouter>
      </Provider>
    </>
  );
};

export default App;
